<template>
  <div class="horizontal scroll hor" ref="track"
    @wheel="horizontalScroll">
    <div
      class="item"
      @click="goToScheduledItem(item.obfuscatedId)"
      v-for="item in filteredMediaScheduleList"
      :key="item.obfuscatedId"
      :class="{ failed: itemStatus(item) === 'Failed' }">
      <p><span>Start date:</span> {{ item.startDayShort }}</p>
      <p><span>Due time:</span> {{ item.days }} days</p>
      <p>
        <span>Locations:</span> {{ item.locationsCount }} <span>Media:</span>
        {{ item.mediaCount }}
      </p>
      <p>{{ itemStatus(item) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filteredMediaScheduleList: {
      type: Array,
      default: () => []
    },
    itemStatus: {
      type: Function
    },
    goToScheduledItem: {
      type: Function
    },
    nextPage: {
      type: Function
    }
  },
  methods: {
    horizontalScroll(event) {
      const modifier = 2
      const { track } = this.$refs
      const startPos = track.scrollLeft
      if (event.deltaY !== 0) {
        track.scrollLeft += modifier * event.deltaY
      }
      if (event.deltaX !== 0) {
        track.scrollLeft += modifier * event.deltaX
      }
      if (startPos !== track.scrollLeft) {
        event.preventDefault()
      }
      if (track.offsetWidth + track.scrollLeft >= track.scrollWidth - 1) {
        this.nextPage()
      }
    }
  }
}
</script>
